module.exports = __webpack_public_path__ + "img/product.a609a995.jpeg";